// extracted by mini-css-extract-plugin
module.exports = {"title":"apps-module--title--65zQT","Link":"apps-module--Link--24Xzo"};